const MAX_DIMENSION = 500;
const MAX_BYTES = 150 * 1024;

export async function resizeImageToJpegBlob(file: File): Promise<Blob> {
  if (!file.type.startsWith("image/")) {
    throw new Error("画像ファイルを選択してください。");
  }

  const image = await loadImage(file);

  let width = image.naturalWidth;
  let height = image.naturalHeight;
  const longestEdge = Math.max(width, height);
  if (longestEdge > MAX_DIMENSION) {
    const scale = MAX_DIMENSION / longestEdge;
    width = Math.max(1, Math.round(width * scale));
    height = Math.max(1, Math.round(height * scale));
  }

  let quality = 0.86;
  let blob = await renderJpeg(image, width, height, quality);

  while (blob.size > MAX_BYTES) {
    if (quality > 0.5) {
      quality -= 0.08;
    } else {
      width = Math.max(1, Math.round(width * 0.9));
      height = Math.max(1, Math.round(height * 0.9));
      quality = 0.82;
    }
    blob = await renderJpeg(image, width, height, quality);
  }

  return blob;
}

function loadImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("画像を読み込めませんでした。"));
    };
    image.src = url;
  });
}

function renderJpeg(
  image: HTMLImageElement,
  width: number,
  height: number,
  quality: number
): Promise<Blob> {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext("2d");
  if (!context) {
    throw new Error("画像変換の初期化に失敗しました。");
  }

  context.drawImage(image, 0, 0, width, height);

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("画像変換に失敗しました。"));
          return;
        }
        resolve(blob);
      },
      "image/jpeg",
      quality
    );
  });
}